export const ACTIVE_ODDS_TAB_KEY = '_activeOddsTab';

export const SELECTED_GAMES_KEY = 'selectedGames';

export const AB_EXPERIMENT_KEY = 'ab_test_experiment_';

export const LOBBY_CLICKED_KEY = 'lobbyClicked';

export const SETTINGS = 'settings';

export const FLASH_ROULETTE_RULES_MODAL_SEEN = 'flashRouletteRulesModalSeen';

export const STARZLE_WELCOME_MODAL_SEEN = 'starzleWelcomeModalSeen';

export const RGS_ROULETTE_LATEST_PAYIN = 'rgsRouletteLatestPayin';
